var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetupGuideIcon = function SvgSetupGuideIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.5 23.22 12 17.781 4.5 23.22V3C4.5 1.76 5.51.75 6.75.75h10.5C18.49.75 19.5 1.76 19.5 3zM12 15.929l6 4.35V3a.75.75 0 0 0-.75-.75H6.75A.75.75 0 0 0 6 3v17.28z",
    clipRule: "evenodd"
  })));
};
export default SvgSetupGuideIcon;